var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      class: {
        [_vm.getClosedStyle("menuItem")]: !_vm.active,
        [_vm.getClosedStyle("activeMenuItem")]: _vm.active,
      },
      on: { click: _vm.openSubModule },
    },
    [
      _c("div", { class: _vm.$style.menuItemContent }, [
        _c(
          "i",
          {
            staticClass: "material-icons",
            class: _vm.active ? _vm.getClosedStyle("activeIcon") : {},
          },
          [_vm._v(_vm._s(_vm.icon))]
        ),
        _vm.open
          ? _c("div", { class: _vm.$style.menuItemContentText }, [
              _vm._v(" " + _vm._s(_vm.text) + " "),
            ])
          : _vm._e(),
        _vm.open && _vm.$slots.default
          ? _c("i", { staticClass: "material-icons" }, [
              _vm._v("arrow_drop_down"),
            ])
          : _vm._e(),
      ]),
      _vm.active && _vm.open && _vm.$slots.default
        ? _c("div", { class: _vm.$style.drop }, [_vm._t("default")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }